import { atom, DefaultValue, selectorFamily } from "recoil";
import { AccordionsExpanded } from "./types";

export const accordionsExpandedState = atom<AccordionsExpanded>({
    key: 'substitutionAccordionsExpandedState',
    default: {
        eventInfo: true,
        assets: true,
        carToReplace: true,
        replacementCar: true
    },
});

export const accordionExpandedState = selectorFamily<boolean, keyof AccordionsExpanded>({
    key: 'accordionExpandedState',
    get: accordionName => ({ get }) => get(accordionsExpandedState)[accordionName],
    set: accordionName => ({ get, set }, newValue) => {
        set(accordionsExpandedState, {
            ...get(accordionsExpandedState),
            [accordionName]: newValue instanceof DefaultValue ? false : newValue
        })
    }
});

export const visibleCarToReplaceAccordion = atom<boolean>({
    key: "carToReplaceAccordion",
    default: true
});
